import { cache } from "react"
import queryString from 'query-string'
import configuredAxios from "helpers/configuredAxios"

const fetchSearchRemoteJobFilter = cache(async (lang) => {
  const axios = await configuredAxios('apiGo')
  const data = await axios.get(`web/search_remote_job_filter?lang=${lang}`)
    .then(res => res.data.data)
    .catch(error =>
      console.error("Get search web3 job filter Error:", error)
    )

  return data ?? {}
})

const fetchSearchRemoteJobPageData = cache(async (payload = {}) => {
  const axios = await configuredAxios('apiGo')
  const data = await axios.post(`web/search_remote_job_v2`, payload)
    .then(res => res.data.data)
    .catch(error =>
      console.error("Get search remote list Error:", error)
    )

  return data ?? {}
})

const fetchSearchRemoteSuggestion = (payload) => {
  const axios = configuredAxios('job')
  return axios.get(`/search-suggestion?${queryString.stringify(payload)}`)
    .then(res => {
      return res.data.data
    })
    .catch(error =>
      console.error("Get search web3 list Error:", error)
    )
}

export async function zipLocation(params) {
  if (params.location?.length > 6) {
    try {
      const [l1, l2, l3, ...rest] = params.locations
      const axios = configuredAxios('apiGo')
      const zippedKey = await axios.post('/url_short/location', { location_seo_values: rest })
        .then(res => {
          return res.data.data?.short_code
        })

      const newParams = {
        ...params,
        location: [l1, l2, l3],
        locationKey: zippedKey
      }
      return newParams
    } catch (error) {
      return params
    }

  }
  return params
}

export async function unzipLocation(searchParams) {
  if (searchParams?.locationKey) {
    try {
      const axios = configuredAxios('apiGo')
      const moreLocations = await axios.get(`/url_short/location?short_code=${searchParams.locationKey}`)
        .then(res => {
          return res.data?.data?.location_seo_values
        })
      if (moreLocations) {
        return {
          ...searchParams,
          location: `${searchParams?.location ?? ''},${moreLocations.join(',')}`
        }
      } else {
        return searchParams
      }

    } catch (error) {
      return searchParams
    }

  }
  return searchParams
}

const fetchSearchSimilarJob = (payload) => {
  const axios = configuredAxios('apiGo')
  return axios.post(`web/search_remote_similar_job`, payload)
}

export {
  fetchSearchRemoteJobFilter,
  fetchSearchRemoteJobPageData,
  fetchSearchRemoteSuggestion,
  fetchSearchSimilarJob
}